import axios from 'axios';
import { goSSO } from '@/utils';
import auth from '@/utils/auth';
import { ignoreMessage } from '@/config/interceptors/whiteList';

// 获取时区
const timeZone = (function timeZone() {
  const dt = new Date();
  const negMinutes = Math.round(dt.getTimezoneOffset() / 15) * 15;
  const minutes = Math.abs(negMinutes);
  const hourOffset = Math.floor(minutes / 60);
  const minuteOffset = minutes % 60;
  return `${
    (negMinutes <= 0 ? 'GMT+' : 'GMT-') + (hourOffset < 10 ? `0${hourOffset}` : hourOffset)
  }:${minuteOffset < 10 ? `0${minuteOffset}` : minuteOffset}`;
})();

// bengin: axios

// 创建请求实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL_WEB,
  withCredentials: true,
  timeout: 60000, // 超时10分钟
});

// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 设置时区
instance.defaults.headers.common['time-zone'] = timeZone;
instance.defaults.headers.common['ecarx-client-id'] = process.env.VUE_APP_CLIENT_ID;

/**
 * get请求
 * @param {string} url 地址
 * @param {object} params 参数
 * @param {object} config axios 额外配置
 * @returns {promise}
 */
const get = function get(url, params, config = {}) {
  return instance.get(url, { params, ...config });
};

/**
 * post请求
 * @param {string} url 地址
 * @param {object} params 参数
 * @param {object} config axios 额外配置
 * @returns {promise}
 */
const post = function post(url, params, config = {}) {
  return instance.post(url, params, config);
};

/**
 * delete 请求
 * @param {string} url 地址
 * @param {object} config axios 额外配置
 * @returns {promise}
 */
const deleteReq = function deleteReq(url, config = {}) {
  return instance.delete(url, config);
};

/**
 * put请求
 * @param {string} url 地址
 * @param {object} params 参数
 * @param {object} config axios 额外配置
 * @returns {promise}
 */
const putReq = function putReq(url, params, config = {}) {
  return instance.put(url, params, config);
};

/**
 * 并行任务
 * @param {object} tasks 并行任务数组
 */
const all = function all(tasks) {
  return axios.all(tasks);
};
// end: axios

/**
 * 拦截请求
 */
instance.interceptors.request.use(
  (config) => {
    config.st = +new Date();
    return config;
  },
  (err) => Promise.reject(err)
);

instance.interceptors.response.use(
  (response) => response,
  (err) => {
    const { message: msg, response, config } = err;
    const { url, method, baseURL, data: _data = {}, params: _params = {}, st = 0 } = config;
    const rt = +new Date() - st;
    const params = {
      url: url.replace(baseURL, ''),
      md: method,
      mg: msg.slice(0, 500),
      code: 'no',
      rt,
      cext: { data: _data, params: _params },
    };
    if (response) {
      params.code = response.status;
      // 根据原拦截错误信息，见下图
      if (params.mg) params.mg = (response.data.message || '').slice(0, 500);
    }
    window.tracker && window.tracker.sendError('xhr', params);
    return Promise.reject(err);
  }
);

/**
 * 拦截响应
 */
instance.interceptors.response.use(
  (res) => {
    // 自定义响应成功逻辑，全局拦截接口，根据不同业务做不同处理，响应成功监控等
    const { headers, data: resData } = res;
    if (headers.username) {
      auth.setUserName(headers.username);
    }
    // 存储clientid信息 单点登录
    if (headers.clientid) {
      auth.setClientId(headers.clientid);
    }
    // 服务器接口头部认证通过时，将 token 存储在客户端
    // TODO：历史问题，可能每个项目有差异，针对文件下载，如果是文件流，直接返回
    const allowContentType = [
      'application/octet-stream;charset=utf-8',
      'application/vnd.ms-excel;charset=utf-8',
      'application/pdf;charset=utf-8',
      'multipart/form-data',
    ];
    if (allowContentType.includes(headers['content-type'])) {
      return resData;
    }
    // 此处 meta 是前后端约定
    const {
      meta: { success, message: msg },
    } = resData;
    return { success, msg, ...resData.content };
  },
  (err) => {
    const { message: msg, response, config } = err;
    let errorMessage = msg;
    if (!response) {
      return Promise.reject(err);
    }
    const { status, data, headers } = response;
    // 存储clientid信息 单点登录
    if (headers.clientid) {
      auth.setClientId(headers.clientid);
    }
    errorMessage = (data.meta && data.meta.message) || data.message || response.statusText;
    switch (status) {
      case 403:
        window.antd.message.error(errorMessage);
        break;
      case 401:
        goSSO();
        break;
      case 404:
        window.antd.message.error(errorMessage);
        break;
      case 500:
        if (!ignoreMessage(config.url)) {
          window.antd.message.error('服务器异常，请联系系统管理员。');
        }
        break;
      default:
    }
    return Promise.reject(new Error(errorMessage));
  }
);

// 导出模块
export default {
  get,
  post,
  delete: deleteReq,
  put: putReq,
  all,
};
